import React from 'react'
import Switch from 'react-switch'

// Components
import ModalError from 'app/views/components/Modals/ModalError'


class LRSSettings extends React.Component {
  constructor(props) {
    super(props)
    this.handleOnEnable = this.handleOnEnable.bind(this)
    this.onTestAndSave = this.onTestAndSave.bind(this)
    this.onRefErrorModal = this.onRefErrorModal.bind(this)
    this.onError = this.onError.bind(this)
  }

  onChangeInput(key, e) {
    this.props.setLrsReducer({
      key,
      value: e.target.value,
    })
  }

  onRefErrorModal(ref) {
    this.error = ref
  }

  onTestAndSave() {
    this.props.triggerLrsIntegration(true, () => {
      this.onError()
    })
  }

  onError() {
    this.error.show()
  }

  handleOnEnable(active) {
    this.props.triggerLrsIntegration(active)
  }

  equalToInitialValues() {
    const {
      initialLrsValues,
      lrsData,
    } = this.props
    const { key, secret, endpoint } = lrsData
    const {
      key: initialKey,
      secret: initialSecret,
      endpoint: initialEndpoint,
    } = initialLrsValues
    if (key === initialKey && secret === initialSecret && endpoint === initialEndpoint) {
      return true
    }
    return false
  }

  render() {
    const {
      lrsData,
    } = this.props
    const {
      endpoint,
      active,
      secret,
      key,
      isLoading,
    } = lrsData
    const isConnected = typeof secret === 'string' && secret.length > 2 && this.equalToInitialValues()
    return (
      <div>
        <div className="uk-inline">
          <h3 className="uk-inline">
            Learning Management System (LMS) Integration
          </h3>
          <a
            href="https://help.hackedu.io/en/articles/3117528-setting-up-a-learning-management-system-lms"
            data-uk-icon="icon: question; ratio: 0.8"
            style={{ padding: 9, verticalAlign: 'top' }}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>
        <div
          className="uk-card uk-card-default uk-card-body"
          style={{
            maxWidth: 750,
          }}
        >
          {isLoading ? (
            <div>
              <div className="uk-margin">
                <div data-uk-spinner="" />
              </div>

            </div>
          ) : (
              <div>
                <div className="uk-margin">
                  <div className="uk-inline">
                    <Switch
                      onChange={this.handleOnEnable}
                      checked={active}
                      id="normal-switch"
                      offColor="#999999"
                      onColor="#1e87f0"
                      checkedIcon={false}
                      uncheckedIcon={false}
                    />
                    {(active) ? (
                      <span className="uk-margin-small-left uk-text-top">
                        Disable LMS Integration
                      </span>
                    ) : (
                      <span className="uk-margin-small-left uk-text-top">
                        Enable LMS Integration
                      </span>
                    )}
                  </div>
                  <p>
                    This integration allows you to sync all your organization progress data with
                    your Learning Record Store (LRS) using xAPI (TinCan).
                  </p>
                  {active && (
                    <>
                      <div className="uk-inline" style={{ width: '100%' }}>
                        <div>
                          LRS endpoint:
                        </div>
                        <input
                          onChange={this.onChangeInput.bind(this, 'endpoint')}
                          type="text"
                          className="uk-input"
                          value={endpoint}
                          placeholder="https://lrs.example.com/endpoint"
                          style={{
                            color: '#1e87f0',
                            paddingRight: '35px',
                          }}
                        />
                      </div>
                      <br />
                      <br />
                      <div className="uk-inline" style={{ width: '100%' }}>
                        <div>
                          LRS Key:
                        </div>
                        <input
                          onChange={this.onChangeInput.bind(this, 'key')}
                          type="text"
                          className="uk-input"
                          value={key}
                          placeholder="Key"
                          // onClick=s{this.handleInviteClick}
                          style={{
                            color: '#1e87f0',
                            paddingRight: '35px',
                          }}
                        />
                      </div>
                      <br />
                      <br />
                      <div className="uk-inline" style={{ width: '100%' }}>
                        <div>
                          LRS Secret:
                        </div>
                        <input
                          onChange={this.onChangeInput.bind(this, 'secret')}
                          type="text"
                          className="uk-input"
                          value={secret}
                          placeholder="Secret"
                          style={{
                            color: '#1e87f0',
                            paddingRight: '35px',
                          }}
                        />
                      </div>
                      <p
                        className={`uk-text-bold${isConnected ? ' uk-text-success' : ' uk-text-danger'}`}
                      >
                        {isConnected ? 'The LRS is connected.' : 'No LRS connected.'}
                      </p>
                      <p className="uk-text-left">
                        <button
                          className="uk-button uk-button-primary uk-modal-close"
                          type="button"
                          disabled={this.equalToInitialValues()}
                          onClick={this.onTestAndSave}
                        >
                          Test and Save
                        </button>
                      </p>
                    </>
                  )}
                </div>
              </div>
          )}
          <ModalError
            onRef={this.onRefErrorModal}
            errorText={`We couldn't connect to your LRS. Please check that your endpoint, secret, and
            key are correct and that you are using https (http is not allowed).`}
          />
        </div>
      </div>
    )
  }
}

export default LRSSettings
